import {combineReducers, Reducer, AnyAction} from '@reduxjs/toolkit';
import reducerConsolidatedBudget from "./reducers/reducerConsolidatedBudget";


interface ConsolidatedBudgetReducers {
    projects: Reducer<any, AnyAction>;
}

const ConsolidatedBudgetStore =
    combineReducers<ConsolidatedBudgetReducers>({ projects: reducerConsolidatedBudget});

export default ConsolidatedBudgetStore;